import store from "../../../store";
import useGlobal from "../../../useGlobal";

export default function useOrderService() {
  const { getData } = useGlobal();

  function getOrderServicePrice() {
    const orderServices = store.getters["orderService/getOrderServices"];
    let price = 0;

    orderServices.map((service) => {
      price += Number(service.price);
    });

    return Number(price);
  }

  function toggleService(event, service) {
    const uncheckedService = !event.target.checked;

    if (uncheckedService) {
      store.commit("orderService/REMOVE_ORDER_SERVICE", service);
    } else {
      store.commit("orderService/PUSH_ORDER_SERVICE", service);
    }
  }

  function isCheckedService(service) {
    const orderServices = store.getters["orderService/getOrderServices"];

    return orderServices.some((orderService) => orderService.id === service.id);
  }

  async function setOrderServices() {
    const dispatchMethod = "orderService/GET_ORDER_SERVICE_OPTIONS";
    const commitMethod = "orderService/SET_ORDER_SERVICE_OPTIONS";

    await getData(dispatchMethod, commitMethod);
  }

  return {
    isCheckedService,
    toggleService,
    setOrderServices,
    getOrderServicePrice,
  };
}
